import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UploadCloud, FileEdit, ArrowRight } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';
import { useToast } from '../common/Toast';

export default function DprLanding() {
  const navigate = useNavigate();
  const { info } = useToast();

  const handleUploadClick = () => {
    info('Upload DPR feature is coming soon!');
  };

  return (
    <>
      <PageBreadcrumb 
        paths={[
          { label: 'Sourcing', url: '/sourcing' },
          { label: 'Requirement Gathering', url: '/sourcing/requirement-gathering' },
          { label: 'DPR', url: '/sourcing/dpr' }
        ]} 
      />
      <PageHeader 
        title="Detailed Project Reports (DPR)" 
        subtitle="Upload an existing DPR or draft a new one using gathered project requirements." 
      />
      <div className="page-container container-fluid px-4">

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', maxWidth: '1000px', margin: '2rem auto 0 auto' }}>
          
          {/* Upload Card */}
          <div>
            <div 
              className="card border-0 shadow-sm h-100 p-4 asset-landing-card"
              style={{ cursor: 'pointer', transition: 'transform 0.2s', borderRadius: '12px' }}
              onClick={handleUploadClick}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div className="d-flex flex-column align-items-center text-center justify-content-center h-100 py-5">
                <div 
                  className="mb-4 d-flex align-items-center justify-content-center"
                  style={{ width: '80px', height: '80px', borderRadius: '50%', background: '#F0F4FF', color: '#4F46E5' }}
                >
                  <UploadCloud size={40} />
                </div>
                <h4 className="fw-bold mb-3">Upload DPR</h4>
                <p className="text-muted mb-4">
                  Already have a finalized Detailed Project Report? Upload the document directly to proceed to the Pre-RFP phase.
                </p>
                <button className="btn btn-outline-primary rounded-pill px-4 py-2 d-flex align-items-center gap-2 mt-auto">
                  Upload Document <ArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>

          {/* Work on Existing Card */}
          <div>
            <div 
              className="card border-0 shadow-sm h-100 p-4 asset-landing-card"
              style={{ cursor: 'pointer', transition: 'transform 0.2s', borderRadius: '12px' }}
              onClick={() => navigate('/sourcing/dpr/existing')}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div className="d-flex flex-column align-items-center text-center justify-content-center h-100 py-5">
                <div 
                  className="mb-4 d-flex align-items-center justify-content-center"
                  style={{ width: '80px', height: '80px', borderRadius: '50%', background: '#FFF0F5', color: '#BE185D' }}
                >
                  <FileEdit size={40} />
                </div>
                <h4 className="fw-bold mb-3">Work on Existing</h4>
                <p className="text-muted mb-4">
                  Draft a brand new Detailed Project Report based on the collaborative requirements gathered by your team.
                </p>
                <button className="btn btn-outline-danger rounded-pill px-4 py-2 d-flex align-items-center gap-2 mt-auto" style={{ borderColor: '#BE185D', color: '#BE185D' }}>
                  Select Project <ArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
